Scan QR <br>
<pre>
{{ScannedData}}
</pre>

<button class="btn btn-secondary" (click)="scan()" [disabled]="disablescan">Scan</button>